import axios from 'axios';
import {all, call, fork, put, takeEvery, select} from "redux-saga/effects";

import {
    REQ_MASTER_VEHICLE_DATA,
    GET_MASTER_VEHICLE_DATA,
    REQ_ADD_MASTER_VEHICLE_DATA,
    GET_ADD_MASTER_VEHICLE_DATA,
    REQ_EDIT_MASTER_VEHICLE_DATA,
    REQ_DELETE_MASTER_VEHICLE_DATA,
    SUCCESS_MESSAGE_MASTER_VEHICLE,
    ERROR_MESSAGE_MASTER_VEHICLE,
    BASE_URL_APIv4,
} from 'constants/ActionTypes';


const key = localStorage.getItem('apiKey')

const getMasterVehicleData = async () => {
    
    return await axios.get(`${BASE_URL_APIv4}/user/cmd/simple-select?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7&client=datatables&params={%22company%22:%22255%22}`)
                .then((res) => res)
                .catch((error) => error.response)
}

const getAddMasterVehicle = async (data) => {
    const obj = JSON.stringify(data)
    // console.log(obj)
    return await axios.post(`${BASE_URL_APIv4}/user?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`, obj)
                .then((res) => res)
                .catch((error) => error.response)
}

const getEditMasterVehicle = async (data) => {
    const obj = JSON.stringify(data.result);
    return await axios.put(`${BASE_URL_APIv4}/user/id/${data.id}?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`, obj)
                .then((res) => res)
                .catch((error) => error.response)
}

const getDeleteMasterVehicle = async (data) => {
    return await axios.delete(`${BASE_URL_APIv4}/user/id/${data}?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`)
                .then((res) => res)
                .catch((error) => error.response)
}




export function* setMasterVehicleData(){
    try {
        const result = yield call(getMasterVehicleData)
        // console.log(result)
        if(result.status == 200){
            const res = result.data.aaData;

            yield put({type: GET_MASTER_VEHICLE_DATA, payload: res})
        } else {
            const err = 'Opps! looks like something wrong'  
            // console.log(err)
        }
    } catch (error) {
        // console.log(error)
    }
}

export function* setAddMasterVehicle(data){
    
    try {
        // console.log('add new MasterVehicle from saga')
        const result = yield call(getAddMasterVehicle, data.action)
        // console.log(result)
        if(result.status == 200){
            const success = 'Data Successfuly Created'
            yield put({type: SUCCESS_MESSAGE_MASTER_VEHICLE, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MASTER_VEHICLE, payload: error})
    }
}

export function* setEditMasterVehicle(data){
   
    try {
        // console.log('add new MasterVehicle from saga')
        // console.log(data.action)
        const result = yield call(getEditMasterVehicle, data.action)
        // console.log(result)
        
        if(result.status == 200){
            const success = 'Data Successfuly Updated'
            yield put({type: SUCCESS_MESSAGE_MASTER_VEHICLE, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MASTER_VEHICLE, payload: error})
    }
}

export function* setDeleteMasterVehicle(data){
   
    try {
        // console.log('add new MasterVehicle from saga')
        // console.log(data.action)
        const result = yield call(getDeleteMasterVehicle, data.action)
        // console.log(result)
        if(result.status == 200){
            const success = 'Data Successfuly Deleted'
            yield put({type: SUCCESS_MESSAGE_MASTER_VEHICLE, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MASTER_VEHICLE, payload: error})
    }
}


export function* reqMasterVehicleData(){
    yield takeEvery(REQ_MASTER_VEHICLE_DATA, setMasterVehicleData)
}

export function* reqAddMasterVehicle(){
    yield takeEvery(REQ_ADD_MASTER_VEHICLE_DATA, setAddMasterVehicle)
}

export function* reqEditMasterVehicle(){
    yield takeEvery(REQ_EDIT_MASTER_VEHICLE_DATA, setEditMasterVehicle)
}

export function* reqDeleteMasterVehicle(){
    yield takeEvery(REQ_DELETE_MASTER_VEHICLE_DATA, setDeleteMasterVehicle)
}

export default function* rootSaga() {
    yield all([
        fork(reqMasterVehicleData),
        fork(reqAddMasterVehicle),
        fork(reqEditMasterVehicle),
        fork(reqDeleteMasterVehicle),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/MasterVehicle.js